import React from 'react';
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';
import Dashboard from '../components/admin/Dashboard';
import ContentManager from '../components/admin/ContentManager';
import Analytics from '../components/admin/Analytics';
import CareersAdmin from '../components/admin/CareersAdmin';
import ContactSubmissions from '../components/admin/ContactSubmissions';
import ConsultationRequests from '../components/admin/ConsultationRequests';
import BackgroundImageManager from '../components/admin/BackgroundImageManager';
import AccountingNewsManager from '../components/admin/AccountingNewsManager';
import AdminAccountManager from '../components/admin/AdminAccountManager';
import AdminLayout from '../components/admin/AdminLayout';
import AdminAuthGuard from '../components/admin/AdminAuthGuard';

const AdminPage: React.FC = () => {
  return (
    <>
      <SignedIn>
        <AdminAuthGuard>
          <AdminLayout>
            {(active) => (
              <>
                {active === 'dashboard' && <Dashboard />}
                {active === 'careers' && <CareersAdmin />}
                {active === 'backgrounds' && <BackgroundImageManager />}
                {active === 'services' && <ContentManager active="services" />}
                {active === 'events' && <ContentManager active="events" />}
                {active === 'posts' && <ContentManager active="posts" />}
                {active === 'comments' && <ContentManager active="comments" />}
                {active === 'accounting-news' && <AccountingNewsManager />}
                {active === 'admin-accounts' && <AdminAccountManager />}
                {active === 'contact' && <ContactSubmissions />}
                {active === 'consultation' && <ConsultationRequests />}
                {active === 'insights' && <Analytics />}
              </>
            )}
          </AdminLayout>
        </AdminAuthGuard>
      </SignedIn>
      <SignedOut>
        <RedirectToSignIn redirectUrl="/admin" />
      </SignedOut>
    </>
  );
};

export default AdminPage;


